<ion-content class="min-h-100">
  <ion-grid
    fixed
    class="h-100 d-grid"
  >
    <div class="px-5 py-6 w-100 flex-shrink-1">
      <div class="text-end">
        <button
          type="button"
          [attr.aria-label]="'getCare.inPerson.close' | translate"
          class="btn btn-link p-0"
          (click)="onClose()"
        >
          <app-icon
            name="close"
            size="16"
            color="var(--n70)"
          ></app-icon>
        </button>
      </div>
    </div>
    <app-consent-iframe
      [key]="key"
      (onDocumentsSigned)="signDocuments($event)"
    ></app-consent-iframe>
  </ion-grid>
</ion-content>
